import { render, staticRenderFns } from "./AddTeamStandingsTournament.vue?vue&type=template&id=413bdf95&scoped=true"
import script from "./AddTeamStandingsTournament.vue?vue&type=script&lang=js"
export * from "./AddTeamStandingsTournament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413bdf95",
  null
  
)

export default component.exports